export default __webpack_public_path__ + "static/media/mixology-tablet-pattern@3x.3cffed93.png";